import { IDetectedBarcode, Scanner } from '@yudiel/react-qr-scanner';
import { isArray } from 'lodash-es';
import React from 'react';
import ScannerOverlay from './ScannerOverlay';
import { Container } from './styles';

const QrScannerPage = () => {
  const handleResult = (result: IDetectedBarcode[]) => {
    if (isArray(result) && result.length > 0) {
      const url = result[0]?.rawValue;
      window.location.href = url;
    }
  };

  return (
    <Container id="qr-scanner-container">
      <Scanner
        onScan={handleResult}
        constraints={{ facingMode: 'environment' }}
        sound={false}
        components={{
          finder: false,
          // @ts-ignore
          audio: false,
        }}
      />
      <ScannerOverlay />
    </Container>
  );
};

export default QrScannerPage;
